<template>
  <div>
    <div class="row justify-content-md-center">
      <div class="col col-md-6 col-lg-4">
        <div class="page-header">
          <h1>Confirm your account</h1>
        </div>
      </div>
    </div>

    <div class="row justify-content-md-center">
      <div class="col col-md-6 col-lg-4">
        <div v-if="accountConfirmed">
          <div class="alert alert-success" role="alert">
            Your account was confirmed
          </div>
        </div>

        <div v-else>
          <div v-if="errorMessage.length > 0" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <p>
            Please enter the token received in your email address below to
            confirm you email account:
          </p>

          <form>
            <div class="form-group">
              <label for="email">Token</label>
              <input type="text" v-model="confirmationToken" name="confirmationToken" class="form-control input-lg"
                v-validate="'required'">
              <span v-show="errors.has('confirmationToken')" class="input-error">
                {{ errors.first('confirmationToken') }}
              </span>
            </div>

            <button type="button" class="btn btn-primary btn-lg" v-on:click="validate()">
              Confirm
            </button>
          </form>
        </div>
      </div>
    </div>
    <br/><br/>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      confirmationToken: this.$route.query.confirmation_token,
      errorMessage: '',
      accountConfirmed: false
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.confirmAccount()
        }
      })
    },
    confirmAccount () {
      var self = this

      this.$http.post('registrations/confirm', { token: this.confirmationToken }).then(function (response) {
        self.accountConfirmed = true
      }).catch(function (error) {
        if (error) {
          self.accountConfirmed = false
          self.errorMessage = error.response.data.message
        }
      })
    }
  }
}
</script>
